"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogAppender = exports.FakeLog = exports.Log = exports.LogManager = exports.LogEvent = exports.LogLevels = void 0;
exports.serializeArguments = serializeArguments;
exports.serializeMessagesArray = serializeMessagesArray;
exports.serializePayload = serializePayload;
var objects_1 = require("../utils/objects");
var stopwatch_1 = require("./stopwatch");
var cancel_1 = require("./cancel");
var dateTime_1 = require("../utils/dateTime");
var string_1 = require("../utils/string");
var errors_1 = require("../cloudcrypt/v3/errors");
var LogLevels = /** @class */ (function () {
    function LogLevels() {
    }
    LogLevels.Info = "INFO";
    LogLevels.Debug = "DEBUG";
    LogLevels.Warn = "WARN";
    LogLevels.Error = "ERROR";
    return LogLevels;
}());
exports.LogLevels = LogLevels;
var LogEvent = /** @class */ (function () {
    function LogEvent(message, level, prefix, payload, timeStamp, url) {
        this.message = message;
        this.level = level;
        this.prefix = prefix;
        this.payload = payload;
        this.timeStamp = timeStamp;
        this.url = url;
    }
    LogEvent.prototype.hasPayload = function () {
        return this.payload && !(0, objects_1.isObjectEmpty)(this.payload);
    };
    return LogEvent;
}());
exports.LogEvent = LogEvent;
var appenders = [];
var LogManager = /** @class */ (function () {
    function LogManager() {
    }
    LogManager.getLog = function (owner) {
        return new Log(owner, appenders);
    };
    LogManager.addAppender = function (appender) {
        appenders.push(appender);
    };
    return LogManager;
}());
exports.LogManager = LogManager;
var opId = 0;
var Log = /** @class */ (function () {
    function Log(owner, appenders) {
        this.owner = owner;
        this.appenders = appenders;
    }
    Log.prototype.info = function (message, payload) {
        try {
            return this.append(LogLevels.Info, message, payload);
        }
        catch (e) { }
        return this;
    };
    Log.prototype.debug = function (message, payload) {
        try {
            return this.append(LogLevels.Debug, message, payload);
        }
        catch (e) {
            this.safeLog(e);
        }
        return this;
    };
    Log.prototype.warn = function (message, payload) {
        try {
            return this.append(LogLevels.Warn, message, payload);
        }
        catch (e) {
            this.safeLog(e);
        }
        return this;
    };
    Log.prototype.error = function (message, exception, payload) {
        try {
            var fromException = exception && exception.details && exception.details.fingerprint;
            var fromPayload = payload && payload.fingerprint;
            var fingerprint = fromPayload || fromException;
            var data = __assign(__assign({}, payload), { exception: exception });
            if (fingerprint)
                data.fingerprint = fingerprint;
            var url = window.location.href;
            return this.append(LogLevels.Error, message, data, url);
        }
        catch (e) {
            this.safeLog(e);
        }
        return this;
    };
    Log.prototype.operation = function (operationName, promise, payload) {
        var _this = this;
        var operation = "op" + opId++;
        var stopwatch = stopwatch_1.Stopwatch.startNew();
        this.info("start", { operationName: operationName, operation: operation, payload: payload });
        return promise.then(function (result) {
            var elapsed = stopwatch.elapsedMilliseconds();
            _this.debug("completed", { operation: operation, result: result, elapsed: elapsed });
            return result;
        }, function (error) {
            var elapsed = stopwatch.elapsedMilliseconds();
            var failEvent = { operationName: operationName, operation: operation, error: error, elapsed: elapsed };
            if ((0, cancel_1.isCancellationError)(error))
                _this.info("cancelled", failEvent);
            else if ((0, errors_1.isUserHasUnconfirmedOperationError)(error))
                _this.warn("unconfirmed operation exists", failEvent);
            else
                _this.error("Failed to ".concat(operationName, ": ").concat(error.message), error, failEvent);
            return Promise.reject(error);
        });
    };
    Log.prototype.append = function (level, message, logData, url) {
        var _this = this;
        this.appenders.forEach(function (appender) {
            appender.append(new LogEvent(message, level, _this.owner, logData, new Date(), url));
        });
        return this;
    };
    Log.prototype.safeLog = function (error) {
        try {
            console && console.log && console.log(error);
        }
        catch (e) {
            throw e;
        }
    };
    return Log;
}());
exports.Log = Log;
var FakeLog = /** @class */ (function () {
    function FakeLog() {
    }
    FakeLog.prototype.info = function (message, payload) {
        return this;
    };
    FakeLog.prototype.debug = function (message, payload) {
        return this;
    };
    FakeLog.prototype.warn = function (message, payload) {
        return this;
    };
    FakeLog.prototype.error = function (message, exception, payload) {
        return this;
    };
    FakeLog.prototype.operation = function (name, promise, payload) {
        return promise;
    };
    return FakeLog;
}());
exports.FakeLog = FakeLog;
function serializeArguments() {
    return serializeMessagesArray(arguments);
}
function serializeMessagesArray(messages, primitiveMaxSize, arrayMaxLength) {
    var logArgs = [];
    for (var i = 0; i < messages.length; i++) {
        var arg = messages[i];
        var depth = arg instanceof Error ? 5 : 2;
        var serialized = (0, objects_1.serialize)(arg, depth, primitiveMaxSize, arrayMaxLength);
        logArgs.push(serialized);
    }
    return logArgs;
}
function serializePayload(payload, totalMaxLength, primitiveMaxSize, arrayMaxLength) {
    var details = (0, objects_1.serialize)(payload, 2, primitiveMaxSize, arrayMaxLength);
    return totalMaxLength ? details.substring(0, totalMaxLength) : details;
}
var ConsoleLogAppender = /** @class */ (function () {
    function ConsoleLogAppender() {
        // https://stackoverflow.com/questions/3326650/console-is-undefined-error-for-internet-explorer
        if (typeof console === "undefined") {
            console = {};
        }
        if (!console.log) {
            console.log = function () { };
        }
        if (typeof console.log === "object") {
            this.info = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                console.log(args.join(" "));
            };
            this.warn = this.info;
            this.error = this.info;
            this.debug = this.info;
        }
        else {
            this.info = console.log;
            this.warn = console.warn ? console.warn : this.info;
            this.error = console.error ? console.error : this.info;
            this.debug = console.log;
        }
    }
    ConsoleLogAppender.prototype.append = function (logEvent) {
        var timestamp = (0, dateTime_1.formatDate)(logEvent.timeStamp, "HH:mm:ss.fff");
        var args = [timestamp, logEvent.prefix, logEvent.message];
        if (logEvent.hasPayload()) {
            var serializedPayload = (0, objects_1.serialize)(logEvent.payload, 2);
            args.push((0, string_1.trim)(serializedPayload, ["{", "}"]));
            var exception = logEvent.payload.exception;
            if (exception) {
                args.push(exception);
            }
        }
        if (logEvent.level === LogLevels.Info) {
            this.info.apply(console, args);
        }
        else if (logEvent.level === LogLevels.Debug) {
            this.debug.apply(console, args); // todo config
        }
        else if (logEvent.level === LogLevels.Error) {
            this.error.apply(console, args);
        }
        else if (logEvent.level === LogLevels.Warn) {
            this.warn.apply(console, args);
        }
    };
    return ConsoleLogAppender;
}());
exports.ConsoleLogAppender = ConsoleLogAppender;
appenders.push(new ConsoleLogAppender());
